// インドの森: カートドロワー同意ガード + 同意記録の永続化（2026-07-04）
// - ドロワーの「ご注文手続き」を同意チェック・5kg上限で保護（/cartページと同等のガード）
// - チェック時に /cart/update.js で attributes を保存し、どの導線からでも注文に同意記録を残す
(function () {
  var WEIGHT_LIMIT = 5000;
  var TOS_VERSION = '2025-11-26';
  var syncTimer = null;

  function drawerBox() {
    return document.getElementById('inm-drawer-consent');
  }

  // インドの森 2026-09-19: 個人輸入代行の同意チェックが描画されているか（海外直送品がカートにあるときだけ描画される）
  function importerRequired() {
    return !!(document.getElementById('importer-confirm') || document.getElementById('importer-confirm-drawer'));
  }

  function drawerConsentOk() {
    var box = drawerBox();
    if (!box) return true; // ブロック未描画（空カート等）はガード対象外
    var a = document.getElementById('importer-confirm-drawer');
    var b = document.getElementById('terms-confirm-drawer');
    // インドの森 2026-09-19: 国内発送品・役務だけのカートは個人輸入代行の同意（a）が描画されない＝規約の同意（b）だけで可
    return !!(b && b.checked && (!a || a.checked));
  }

  // インドの森 2026-09-05: 購入できない行（available == false）がカートに残っていると
  // チェックアウトは Shopify 側で必ず弾かれるので、ドロワーでも理由を出して止める。
  // 目印はカートページ側にも同じ名前で出るため、必ず #CartDrawer 配下に限定して探す。
  function drawerUnavailable() {
    var el = document.querySelector('#CartDrawer .inm-cart-unavailable-flag');
    if (!el) return 0;
    var n = parseInt(el.getAttribute('data-count'), 10);
    return isNaN(n) ? 0 : n;
  }

  // インドの森 2026-10-03: 1 回の上限（custom.max_per_order）を超えた行（snippets/inm-max-per-order.liquid）
  function drawerOverQty() {
    var el = document.querySelector('#CartDrawer .inm-cart-overqty-flag');
    if (!el) return 0;
    var n = parseInt(el.getAttribute('data-count'), 10);
    return isNaN(n) ? 0 : n;
  }

  function drawerWeight() {
    var box = drawerBox();
    if (!box) return 0;
    var w = parseInt(box.getAttribute('data-cart-weight'), 10);
    return isNaN(w) ? 0 : w;
  }

  function pageConsentOk() {
    var a = document.getElementById('importer-confirm');
    var b = document.getElementById('terms-confirm');
    if (!b) return true;
    if (!a) return b.checked; // 2026-09-19: 国内発送品・役務だけのカート
    return a.checked && b.checked;
  }

  function updateDrawerUi() {
    var box = drawerBox();
    if (!box) return;
    var ok = drawerConsentOk();
    var over = drawerWeight() > WEIGHT_LIMIT;
    var unavail = drawerUnavailable() > 0;
    var overqty = drawerOverQty() > 0;
    var hiddenTerms = document.getElementById('attr-terms-accepted-drawer');
    var hiddenImporter = document.getElementById('attr-importer-self-drawer');
    if (hiddenTerms) hiddenTerms.value = ok ? 'true' : 'false';
    if (hiddenImporter) hiddenImporter.value = importerRequired() ? (ok ? 'true' : 'false') : 'not-required';

    var btn = document.getElementById('CartDrawer-Checkout');
    if (btn) {
      if (over || !ok || unavail || overqty) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('button--disabled');
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('button--disabled');
      }
    }
    var warn = box.querySelector('.inm-drawer-consent__weight-warning');
    if (warn) warn.style.display = over ? '' : 'none';
    var err = document.getElementById('inm-drawer-consent-error');
    if (err && ok) err.style.display = 'none';

    // ドロワーはスクロールするため、固定CTAの上に「なぜ押せないか」を表示する（2026-08-20）
    var ctas = document.querySelector('#CartDrawer .cart__ctas');
    if (ctas) {
      var hint = ctas.querySelector('.inm-cta-hint');
      if (over || !ok || unavail || overqty) {
        if (!hint) {
          hint = document.createElement('button');
          hint.type = 'button';
          hint.className = 'inm-cta-hint';
          hint.addEventListener('click', function () {
            var target = drawerBox();
            if (target && target.scrollIntoView) {
              target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          });
          ctas.insertBefore(hint, ctas.firstChild);
        }
        var msg = unavail
          ? '⚠ 購入できない商品がカートに入っています。削除すると注文手続きに進めます。'
          : overqty
          ? '⚠ 1回のご注文で購入できる数を超えている商品があります。数量を減らしてください。'
          : over
          ? '⚠ 合計重量が5kgを超えています。カート内の商品を調整してください。'
          : '購入手続きに進むには、同意事項にチェックしてください（タップで移動）';
        // MutationObserver の無限ループを避けるため、変化がある時だけ書き換える
        if (hint.textContent !== msg) hint.textContent = msg;
        if (hint.hidden) hint.hidden = false;
      } else if (hint && !hint.hidden) {
        hint.hidden = true;
      }
    }
  }

  // 同意状況をカート属性としてサーバー保存（注文画面に引き継がれる）
  function persistConsent(ok) {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            terms_accepted: ok ? 'true' : 'false',
            importer_self_confirmed: importerRequired() ? (ok ? 'true' : 'false') : 'not-required',
            tos_version: TOS_VERSION,
            consent_recorded_at: ok ? new Date().toISOString() : ''
          }
        })
      }).catch(function () {});
    }, 250);
  }

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.classList) return;
    if (e.target.classList.contains('js-inm-drawer-agree')) {
      updateDrawerUi();
      persistConsent(drawerConsentOk());
    }
    // /cartページ側のチェックボックスもサーバー保存の対象にする
    if (e.target.classList.contains('js-indonomori-agree')) {
      persistConsent(pageConsentOk());
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#CartDrawer-Checkout');
    if (!btn) return;
    var over = drawerWeight() > WEIGHT_LIMIT;
    if (over || drawerUnavailable() > 0 || drawerOverQty() > 0 || !drawerConsentOk()) {
      e.preventDefault();
      e.stopPropagation();
      var err = document.getElementById('inm-drawer-consent-error');
      if (err && !drawerConsentOk()) err.style.display = 'block';
      var box = drawerBox();
      if (box && box.scrollIntoView) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

  // ドロワーはSection Rendering APIで再描画されるため監視して再適用
  if (window.MutationObserver) {
    var target = document.body;
    var obs = new MutationObserver(function () {
      updateDrawerUi();
    });
    obs.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateDrawerUi);
  } else {
    updateDrawerUi();
  }
})();
